<template>
  <div class="message-notify-component">
    <img v-if="getMessageIcon()" :src="require(`@/assets/images/${getMessageIcon()}`)" />
    <div class="message-notify-component__message m-t-20 m-b-20">
      {{ message }}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AppMessageNotifier",
  props: {
    messageType: {
      type: String,
      required: false
    },
    messageId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      message: ""
    };
  },
  methods: {
    ...mapActions({ removeMessages: "messages/removeMessages" }),
    getMessageIcon() {
      const messageIcon = {
        success: "check-circle.svg",
        error: "exclamation-circle.svg",
        warn: "warning.svg"
      };
      return messageIcon[this.messageType];
    }
  },
  computed: {
    ...mapGetters({
      getMessage: "messages/getMessageById"
    })
  },
  mounted() {
    this.message = this.getMessage(this.messageId)["message"];
    this.removeMessages([this.messageId]);
  }
};
</script>

<style scoped lang="scss">
.message-notify-component {
  display: flex;
  align-items: center;
  background-color: $primary-color;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  border: solid 1px #e3e3e3;
  color: #333;
  font-weight: 500;
  height: 70px;
  padding: 0 1rem 0 1rem;

  &__message {
    font-weight: bolder;
    padding: 0 0.5rem 0 0.5rem;
  }

  @include respond-to-mobile {
    font-size: 0.9em;
  }
}
</style>
